import { render, staticRenderFns } from "./tjhcDialog.vue?vue&type=template&id=1f8aebf6&scoped=true&"
import script from "./tjhcDialog.vue?vue&type=script&lang=js&"
export * from "./tjhcDialog.vue?vue&type=script&lang=js&"
import style0 from "./tjhcDialog.vue?vue&type=style&index=0&id=1f8aebf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8aebf6",
  null
  
)

export default component.exports